import { useStore } from 'dg-web-shared/lib/Flux';
import { InputContext } from 'dg-web-shared/tb-ui/inputs/InputContext.ts';
import {
    LabeledToggle,
    ToggleType,
} from 'dg-web-shared/tb-ui/toggle/LabeledToggle.tsx';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { CurrentLoginState } from '../../common/state/CurrentLoginState';
import { SlideInPortalId } from '../root/components/PortalSlidein';
import { EditFormSlideIn } from './EditForm';
import { EditFormState } from './EditFormState';
import { GetLoginData } from './state/LoginsState';
import { Spinner } from 'dg-web-shared/ui/Spinner';

export function RoleEditFormSlideIn(props: {
    portal: SlideInPortalId;
    title: React.ReactNode;
    open: boolean;
    login: GetLoginData | null;
    onClose: () => void;
}) {
    const { storeState } = useStore(s => ({
        edit: new EditFormState.StateSlice(s).state,
        legacyUpdater: s.legacyUpdater,
    }));

    if (!props.login) {
        return (
            <EditFormSlideIn isSaveable={false} {...props}>
                <Spinner />
            </EditFormSlideIn>
        );
    }

    const role =
        storeState.edit.role === null
            ? props.login.roleId
            : storeState.edit.role;

    return (
        <EditFormSlideIn isSaveable={role !== props.login.roleId} {...props}>
            <LabeledToggle
                type={ToggleType.checkbox}
                context={InputContext.form}
                label={
                    <Localized
                        de="Administrator"
                        fr="Administrateur"
                        it="Amministratore"
                        en="Administrator"
                    />
                }
                selected={role === CurrentLoginState.LoginRole.ADMIN}
                onClick={() => {
                    storeState.legacyUpdater(
                        args => EditFormState.writeRole(args!),
                        role === CurrentLoginState.LoginRole.ADMIN
                            ? CurrentLoginState.LoginRole.RESTRICTED
                            : CurrentLoginState.LoginRole.ADMIN,
                    );
                }}
            />
        </EditFormSlideIn>
    );
}
